"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostCenter1BudgetEnum = void 0;
var CostCenter1BudgetEnum;
(function (CostCenter1BudgetEnum) {
    CostCenter1BudgetEnum["ABOVE_BUDGET"] = "above_budget";
    CostCenter1BudgetEnum["WITHIN_BUDGET"] = "within_budget";
})(CostCenter1BudgetEnum || (exports.CostCenter1BudgetEnum = CostCenter1BudgetEnum = {}));
